var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-card',{attrs:{"title":"Device Detail","header":_vm.deviceDetails,"data":_vm.singleDevice,"height":_vm.row1Height}})
}
var staticRenderFns = []

export { render, staticRenderFns }